import { LegalPage } from "../../components/LegalPage";

export function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      description="WeConsult Rx terms of service: acceptable use, account responsibilities, intellectual property, liability, termination, and governing law."
      path="/terms"
      effective="2026-05-30"
    >
      <p>
        These Terms of Service (“Terms”) govern access to and use of
        weconsultrx.com (the “Site”) and the WeConsult Rx platform (the
        “Service”). By using the Service you agree to these Terms.
      </p>

      <h2>Accounts and eligibility</h2>
      <p>
        You represent that you are authorized to bind the entity (the
        “Customer”) on whose behalf you accept these Terms, and that you and the
        Customer will comply with applicable laws, including HIPAA.
      </p>

      <h2>Acceptable use</h2>
      <p>
        You agree not to use the Service to (a) violate applicable law; (b)
        infringe intellectual property rights; (c) transmit malware or perform
        unauthorized scanning; (d) reverse engineer the Service except as
        permitted by law; or (e) interfere with the Service’s integrity or
        availability. See our <a href="/aup">Acceptable Use Policy</a> for
        details.
      </p>

      <h2>Customer content</h2>
      <p>
        You retain ownership of all content you upload to the Service,
        including Protected Health Information. We process PHI only as a
        Business Associate under a signed BAA.
      </p>

      <h2>Service availability</h2>
      <p>
        Uptime targets are described in our <a href="/sla">SLA</a>. The Site
        and Service are provided on a best-efforts basis except as expressly
        modified by a Master Services Agreement.
      </p>

      <h2>Fees</h2>
      <p>
        Fees, billing intervals, and trial terms are described in an Order Form
        executed by the Customer. Unpaid fees may result in suspension after
        notice.
      </p>

      <h2>Intellectual property</h2>
      <p>
        The Site, Service, code, documentation, and underlying technology are
        the property of WeConsult Rx and its licensors. Customer is granted a
        non-exclusive, non-transferable right to use the Service during the
        subscription term.
      </p>

      <h2>Confidentiality</h2>
      <p>
        Each party will protect the other’s Confidential Information using a
        standard of care no less than reasonable care.
      </p>

      <h2>Warranties &amp; disclaimers</h2>
      <p>
        We warrant that the Service will materially conform to our published
        documentation. EXCEPT AS EXPRESSLY PROVIDED, THE SERVICE IS PROVIDED
        “AS IS” WITHOUT WARRANTY OF ANY KIND.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, EACH PARTY’S TOTAL LIABILITY
        UNDER THESE TERMS WILL NOT EXCEED THE FEES PAID BY CUSTOMER IN THE
        TWELVE (12) MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
        NEITHER PARTY WILL BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, OR
        CONSEQUENTIAL DAMAGES.
      </p>

      <h2>Indemnification</h2>
      <p>
        Each party will indemnify the other against third-party claims arising
        from its breach of these Terms, subject to the procedures customary in
        commercial SaaS agreements.
      </p>

      <h2>Termination</h2>
      <p>
        Either party may terminate for material breach after notice and
        cure. Upon termination Customer data is returned or deleted in
        accordance with the BAA.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of Florida, USA,
        without regard to conflict of laws principles. Disputes will be heard
        in the state or federal courts of Broward County, Florida.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these Terms. Material changes will be posted with an
        updated effective date and (for active customers) notified by email.
      </p>

      <h2>Contact</h2>
      <p>legal@weconsultrx.com</p>
    </LegalPage>
  );
}
